import { getStartPageConfig, getWishListItems } from './api';
import {
    setStartPageConfigAction,
    setStartPageConfigStatusAction,
    setWishListAction,
    setWishListStatusAction,
    setItemQueryUsed
} from './reducer';
import { mapConfig } from './configuration-mapper';
import { selectPreferredLanguage } from 'tradera/state/language/selectors';
import * as itemActions from 'tradera/state/items/actions';
import { selectIsLoggedIn } from 'tradera/state/member/selectors';

export const fetchStartPageConfig = () => async (dispatch, getState) => {
    const { status } = getState().views.startPage;
    const isLoggedIn = selectIsLoggedIn(getState());
    if (status !== 'NOT_FETCHED') return;

    dispatch(setStartPageConfigStatusAction({ status: 'LOADING' }));

    const config = await getStartPageConfig(
        selectPreferredLanguage(getState()).languageCodeIso2
    );

    dispatch(
        setStartPageConfigAction({
            config: mapConfig(config, isLoggedIn),
            status: 'HAS_DATA'
        })
    );
};

export const fetchWishList = (itemsPerPage) => async (dispatch, getState) => {
    const { status } = getState().views.startPage.wishList;
    if (status === 'LOADING') return;

    dispatch(setWishListStatusAction({ status: 'LOADING' }));

    const response = await getWishListItems(itemsPerPage);
    const { items = [] } = response;

    dispatch(itemActions.addItemsToWishList(items.map((x) => x.itemId)));
    const newStatus = items.length > 0 ? 'HAS_DATA' : 'HAS_NO_DATA';
    dispatch(
        setWishListAction({
            items: items,
            status: newStatus,
            totalCount: response.totalCount ?? 0
        })
    );
};

export const getItemQuery = () => (dispatch, getState) => {
    const itemQueries = getState().views.startPage.itemQueries;

    const shuffledArray = [...itemQueries].sort(() => 0.5 - Math.random());

    const itemQuery = shuffledArray.find((query) => !query.used);

    dispatch(setItemQueryUsed({ id: itemQuery?.id }));

    return itemQuery;
};
